import { CloseIcon } from '@/app/icons/CloseIcon';
import { DialogTitle, Grid, IconButton, Typography } from '@mui/material';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';
import React, { FC, ReactNode } from 'react';

/**
 * Accessible name of the control in the title row, for the usual case where it closes the dialog.
 */
const CLOSE_LABEL = 'Закрыть';

interface Props {
  label: ReactNode;
  id?: string;
  sx?: SxProps<Theme>;
  closeLabel?: string;
  onClose: () => void;
}

export const ClientDialogTitle: FC<Props> = (props: Props) => {
  const { label, id, sx, closeLabel, onClose } = props;
  return (
    <DialogTitle id={id} sx={sx}>
      <Grid container={true} justifyContent={'space-between'} wrap={'nowrap'}>
        <Grid item={true}>
          <Typography variant={'h1'} data-testid={'dialog-title'}>
            {label}
          </Typography>
        </Grid>
        <Grid item={true}>
          <IconButton
            disableRipple={true}
            onClick={onClose}
            aria-label={closeLabel ?? CLOSE_LABEL}
            data-testid={'dialog-close'}
            sx={(theme: Theme) => ({
              marginTop: theme.spacing(-1),
              marginRight: theme.spacing(-1),
            })}>
            <CloseIcon color={'primary'} />
          </IconButton>
        </Grid>
      </Grid>
    </DialogTitle>
  );
};
